import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../lib/auth-context';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children }) {
  const { user, loading, supabaseEnabled } = useAuth();
  const location = useLocation();

  // Dev-mode bypass: if Supabase isn't configured, let everything through
  if (!supabaseEnabled) return children;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" state={{ from: location }} replace />;

  return children;
}
